














import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
// import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
// import { mapGetters, mapActions } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'

@Component({
  components: {
    ToggleButton,
  },
})
export default class CustomSwitch extends Vue {
  @Prop({ default: '' }) private itemId!: string
  @Prop({ default: false }) private itemStatus!: boolean
  @Prop() private labels!: { checked: string; unchecked: string } | string
  @Prop({ default: 50 }) private width!: number
  @Prop({ default: 22 }) private height!: number
  @Prop({ default: 8 }) private fontSize!: number
  @Prop() private onChange!: (id: string, status: boolean) => void

  get currentStatus() {
    return this.itemStatus
  }
}
